/* eslint-disable no-console */
import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { ErrorMessage } from 'formik';

const FormikInputFieldV2 = ({
  field: { ...fields },
  form: { touched, errors, setFieldValue, handleBlur, setFieldTouched },
  label,
  id,
  required,
  disabled = false,
  ...rest
}) => {
  const { name } = fields;
  const handleChange = (e) => {
    const { value } = e.target;
    setFieldValue(name, value, true);
  };
  const handleFocus = () => {
    setFieldTouched(name, true, true);
  };
  return (
    <FormGroup className="flex-grow-1">
      {label && (
        <Label
          for={id}
          className={`text-dark text-nowrap ${disabled ? 'disabled' : ''} fw-medium mb-2`}
        >
          {label}
          {required && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
        </Label>
      )}
      <Input
        {...fields}
        onChange={handleChange}
        onFocus={handleFocus}
        invalid={Boolean(touched[name] && errors[name])}
        onBlur={handleBlur}
        disabled={disabled}
        {...rest}
      />

      <ErrorMessage
        name={name}
        render={(msg) => {
          return <div className="text-danger f-12">{msg}</div>;
        }}
      />
    </FormGroup>
  );
};

export default FormikInputFieldV2;
